import React from 'react';
import * as _Builtin from './_Builtin';
import * as _utils from './utils';
import _styles from './DevlinkContentBlockLeftText.module.css';

export function DevlinkContentBlockLeftText({
  as: _Component = _Builtin.Section,
  showEyebrowText = true,
  eyebrowText = 'Eyebrow',
  mainTitle = 'Main Title',
  showBodyText = true,
  bodyText = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse varius enim in eros elementum tristique. Duis cursus, mi ',
  showButtonGroup = false,
  buttonGroup,
  showImageFill = true,
  imageFill = '',
  showImageFit = false,
  imageFit = '',
  showImageSlot = false,
  imageSlot,
  hasBgColor = false,
}) {
  return (
    <_Component
      className={_utils.cx(_styles, 'position-relative')}
      grid={{
        type: 'section',
      }}
      tag="section"
    >
      {hasBgColor ? <_Builtin.Block className={_utils.cx(_styles, 'large')} tag="div" /> : null}
      <_Builtin.Block className={_utils.cx(_styles, 'ht-container', 'lg')} tag="div">
        <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block')} tag="div">
          <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block-content')} tag="div">
            {showEyebrowText ? (
              <_Builtin.Block tag="div">
                <_Builtin.Block className={_utils.cx(_styles, 'overline-text-sm')} tag="div">
                  {eyebrowText}
                </_Builtin.Block>
                <_Builtin.Block className={_utils.cx(_styles, 'small-1')} tag="div" />
              </_Builtin.Block>
            ) : null}
            <_Builtin.Heading tag="h3">{mainTitle}</_Builtin.Heading>
            {showBodyText ? (
              <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block-body')} tag="div">
                <_Builtin.Block className={_utils.cx(_styles, 'small')} tag="div" />
                <_Builtin.Paragraph className={_utils.cx(_styles, 'txt-body-md')}>{bodyText}</_Builtin.Paragraph>
              </_Builtin.Block>
            ) : null}
            {showButtonGroup ? (
              <_Builtin.Block tag="div">
                <_Builtin.Block className={_utils.cx(_styles, 'small-2')} tag="div" />
                <_Builtin.Block className={_utils.cx(_styles, 'ht-button-group')} tag="div">
                  {buttonGroup}
                </_Builtin.Block>
              </_Builtin.Block>
            ) : null}
          </_Builtin.Block>
          <_Builtin.Block className={_utils.cx(_styles, 'ht-column-block-img')} tag="div">
            {showImageFill ? (
              <_Builtin.Image className={_utils.cx(_styles, 'ht-inner-img')} loading="lazy" width="auto" height="auto" alt="" src={imageFill} />
            ) : null}
            {showImageFit ? (
              <_Builtin.Image
                className={_utils.cx(_styles, 'ht-inner-img', 'ht-fit')}
                loading="lazy"
                width="auto"
                height="auto"
                alt=""
                src={imageFit}
              />
            ) : null}
            {showImageSlot ? (
              <_Builtin.Block className={_utils.cx(_styles, 'ht-image-slot')} tag="div">
                {imageSlot}
              </_Builtin.Block>
            ) : null}
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      {hasBgColor ? <_Builtin.Block className={_utils.cx(_styles, 'large')} tag="div" /> : null}
      {hasBgColor ? <_Builtin.Block className={_utils.cx(_styles, 'ht-bg-color', 'bg-n100')} tag="div" /> : null}
    </_Component>
  );
}
